import axiosInstance from './AxiosInstance';

export default class VotersService {
    constructor() {
        this.endpoint = "/api/voters"
    }
    async getAllVoters(params) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getByRegNumber(regNumber) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/regNumber/${regNumber}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getByIDNumber(idNumber) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/idnumber/${idNumber}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async searchVoter(param) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/search/${param}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getAmendmentOriginalDetailsByApplicationID(applicationID) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/originaldetails/${applicationID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getByID(voterID) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/${voterID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getAuditByIDNumber(idNumber) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/audit/idnumber/${idNumber}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getAuditByRegNumber(regNumber) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/audit/regNumber/${regNumber}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getHistoryByIDNumber(idNumber) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/history/idnumber/${idNumber}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getHistoryByRegNumber(regNumber) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/history/regNumber/${regNumber}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    searchRepresentative = (query) => {
        const params = new URLSearchParams(query).toString();
        const url = `/API/VoterRepresentatives?${params}`;
        return axiosInstance.get(url).then((response) => response.data);
    };
}

const votersService = new VotersService();

export { votersService };
